export function getEthiopianMonth(gmonth: number): string {
    const ethiopianMonths : { [key: number]: string } = {
        1 : "መስከረም",
        2 : "ጥቅምት",
        3 : "ህዳር",
        4 : "ታህሳስ",
        5 : "ጥር",
        6 : "የካቲት",
        7 : "መጋቢት",
        8 : "ሚያዝያ",
        9 : "ግንቦት",
        10 : "ሰኔ",
        11 : "ሐምሌ",
        12 : "ነሐሴ",
        13 : "ጳጉሜን"
    }

    return ethiopianMonths[gmonth] || "" }


    export function getDay(gmonth: number, lan: string): string {
        if (lan === "am") {
            const dayNamesAm : { [key: number]: string } = {
                1 : "ሰኞ",
                2 : "ማክሰኞ",
                3 : "ረቡዕ",
                4 : "ሐሙስ",
                5 : "ዓርብ",
                6 : "ቅዳሜ",
                7 : "እሁድ",
            }
    
            return dayNamesAm[gmonth] || "" }
    const dayNames : { [key: number]: string } = {
        1 : "Monday",
        2 : "Tuesday",
        3 : "Wednesday",
        4 : "Thursday",
        5 : "Friday",
        6 : "Saturday",
        7 : "Sunday",
    }

    return dayNames[gmonth] || "" }

    export function getShortDay(gmonth: number): string {
        const dayNames : { [key: number]: string } = {
            1 : "Mon",
            2 : "Tue",
            3 : "Wed",
            4 : "Thu",
            5 : "Fri",
            6 : "Sat",
            7 : "Sun",
        }
    
        return dayNames[gmonth] || "" }

export function toEthiopianTime(time12h: string, modifier:string): string  {
  // Parse "hh:mm AM/PM"
 
  let [hours, minutes] = time12h.split(":").map(Number);

  // Convert to 24-hour format
  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  // Convert to Ethiopian time (subtract 6 hours)
  let ethHours = hours - 6;
  if (ethHours < 0) ethHours += 24; // wrap around midnight

  // Determine Ethiopian AM/PM
  const ethModifier = ethHours >= 12 ? "PM" : "AM";

  // Convert back to 12-hour format for Ethiopian time
  ethHours = ethHours % 12 || 12; // handle 0 -> 12

  // Format nicely
  return `${ethHours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
}
